import { Palette, Wallpaper, Columns3 } from 'lucide-react';
import { BackgroundConfig } from '../types';

interface BackgroundSelectorProps {
  currentBackground: BackgroundConfig;
  onBackgroundChange: (background: BackgroundConfig) => void;
}

const gradients = [
  'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
  'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
  'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
];

const colors = [
  '#1a2235', '#000000', '#ffffff', '#666666',
  '#333333', '#dc2626', '#ea580c', '#d97706',
  '#65a30d', '#16a34a', '#059669', '#0d9488',
  '#0284c7', '#2563eb', '#4f46e5', '#7c3aed',
];

export function BackgroundSelector({ currentBackground, onBackgroundChange }: BackgroundSelectorProps) {
  return (
    <div>
      <div className="setting-section">
        <div className="background-section-title">
          <Wallpaper size={16} />
          <h2>Background</h2>
        </div>
        <div className="background-section-title">
          <Columns3 size={16} />
          <h3>Gradients</h3>
        </div>
        <div className="gradient-grid">
          {gradients.map((gradient, index) => (
            <button
              key={index}
              onClick={() => onBackgroundChange({ type: 'gradient', value: gradient })}
              className={`gradient-button ${
                currentBackground.type === 'gradient' && currentBackground.value === gradient
                  ? 'active'
                  : ''
              }`}
              style={{ background: gradient }}
            />
          ))}
        </div>
      </div>
          <br/>
      <div className="setting-section">
        <div className="background-section-title">
          <Palette size={16} />
          <h3>Solid Colors</h3>
        </div>
        <div className="color-grid">
          {colors.map((color) => (
            <button
              key={color}
              onClick={() => onBackgroundChange({ type: 'color', value: color })}
              className={`color-button ${
                currentBackground.type === 'color' && currentBackground.value === color
                  ? 'active'
                  : ''
              }`}
              style={{ backgroundColor: color }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

{/* 
        <div className="setting-section">
        <div className="background-section-title">
          <Image size={16} />
          <h3>Custom Image URL</h3>
        </div>
        <input
          type="url"
          placeholder="Enter image URL..."
          className="image-input"
          onChange={(e) => {
            if (e.target.value) {
              onBackgroundChange({ type: 'image', value: e.target.value });
            }
          }}
        />
      </div>
  */}